module.exports = __webpack_public_path__ + "static/media/AdminLTELogo.28f7e31d.png";


//////////////////
// WEBPACK FOOTER
// ./src/adminlte3/dist/img/AdminLTELogo.png
// module id = 164
// module chunks = 0